import { User } from './user';
import { DepositStatsModel } from './deposit-stats.model';
import { UserSocketVerificationStatus } from './user-socket-verification-status';

export enum WebsocketEventType {
  Payment = 6,
  UserUpdated = 7,
  UserEmailConfirmed = 8,
  UserBlocked = 11,
  UserDepositStatsUpdated = 12,
  UserVerified = 19,
}

export interface WebsocketEvent<T> {
  response: T;
  eventType: WebsocketEventType;
}

export interface DepositEvent {
  depositAccepted: DepositStatsModel;
}

export interface UserUpdatedEvent {
  user: User;
}

export interface UserVerifiedEvent {
  verification: UserSocketVerificationStatus;
}
